
class CollectionSorting extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form#coll_main_sorting_form');
    this.select = this.querySelector('select[name="sort_by"]');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.select.addEventListener('change', () => {
      const value = this.select.value;

      this.showLoader();

      const url = new URL(window.location.href, window.location.origin);
      url.searchParams.set('sort_by', value);
      url.searchParams.set('sections', this.sectionId);

      this.updatePage(url, this.sectionId);     

      this.updateURL(url);
    }) 
  }

  showLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');

    if(loader) {
      loader.classList.remove('hidden');
    }

    this.select.disabled = true;
  }

  hideLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');

    if(loader) {
      loader.classList.add('hidden');
    }

    this.select.disabled = false;
  }

  updatePage(url, id) {
    fetch(url.toString())
    .then((res) => res.json())
    .then((htmlString) => {
      const temp = document.createElement('div');
      temp.innerHTML = htmlString[id];
      const newWrapper = temp.querySelector('.coll_main_main_inner');
      const oldWrapper = document.querySelector('.coll_main_main_inner');

      if(oldWrapper && newWrapper) {
        oldWrapper.innerHTML = newWrapper.innerHTML
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url: url,
            sectionId: this.sectionId
          }
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err)
    })
    .finally(() => {
      this.hideLoader();
    })
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    window.history.pushState({}, '', url.toString())
  }
}

customElements.define('collection-sorting', CollectionSorting);


class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input[type="checkbox"]');
    this.priceInputs = this.querySelectorAll('input[type="number"]');
    this.sectionId = this.dataset.sectionId;
    this.sortSelect = document.querySelector('select[name="sort_by"]');
    this.activeTags = this.querySelectorAll('.active_values_wrapper a');
  }

  connectedCallback() {
    this.bindCheckboxFilters();
    this.bindPriceInputs();
    this.bindActiveValueRemoval();
  }

  bindCheckboxFilters() {
    this.inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        this.showLoader();

        const url = new URL(
          e.currentTarget.checked
            ? e.currentTarget.dataset.addUrl
            : e.currentTarget.dataset.removeUrl,
          window.location.origin
        );

        url.searchParams.set('sections', this.sectionId);

        this.updatePage(url);
        this.updateURL(url);
      });
    });
  }

  bindPriceInputs() {
    const debouncedHandler = debounce(() => {
      this.showLoader();

      const url = new URL(window.location.href);

      this.priceInputs.forEach(input => {
        input.value
          ? url.searchParams.set(input.name, input.value)
          : url.searchParams.delete(input.name);
      });

      url.searchParams.set('sections', this.sectionId);

      this.updatePage(url);
      this.updateURL(url);
    }, 800);

    this.priceInputs.forEach(input => {
      input.addEventListener('input', debouncedHandler);
    });
  }

  bindActiveValueRemoval() {
    this.activeTags.forEach(tag => {
      tag.addEventListener('click', (e) => {
        e.preventDefault();
        this.showLoader();

        const url = new URL(tag.getAttribute('href'), window.location.origin);
        url.searchParams.set('sections', this.sectionId);

        this.updatePage(url);
        this.updateURL(url);
      });
    });
  }

  updatePage(url) {
    fetch(url.toString())
      .then(res => res.json())
      .then(sectionHTML => {
        const html = document.createElement('div');
        html.innerHTML = sectionHTML[this.sectionId];

        this.replaceContent(html, '.coll_main_main_inner');
        this.replaceContent(html, '.collection_products_count');
        this.replaceContent(html, '.mobile_filter_drawer');

        document.dispatchEvent(new CustomEvent('collection-grid-update', {
          detail: { url: url.toString(), sectionId: this.sectionId }
        }));
      })
      .catch(err => console.error('Filter error:', err))
      .finally(() => this.hideLoader());
  }

  replaceContent(tempHTML, selector) {
    const newEl = tempHTML.querySelector(selector);
    const oldEl = document.querySelector(selector);
    if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    history.pushState({}, '', url.toString());
  }

  showLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');
    if (loader) loader.classList.remove('hidden');
    if (this.sortSelect) this.sortSelect.disabled = true;
  }

  hideLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');
    if (loader) loader.classList.add('hidden');
    if (this.sortSelect) this.sortSelect.disabled = false;
  }
}

customElements.define('collection-filters', CollectionFilters);

function debounce(fn, delay = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}


class MobileFilters extends HTMLElement {
  constructor() {
    super();
    this.loader = document.querySelector('.coll_main_grid_wrapper .loader');
    this.collectionGrid = document.querySelector('.coll_main_main_inner');
    this.btn = this.querySelector('.mobile_filters_btn button');
    this.form = this.querySelector('form#mobile_filters_form');
    this.drawer = document.querySelector('.mobile_filter_drawer');
    this.activeValues = this.querySelectorAll('.mob_active_values_wrapper a');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.attachListeners();
  }

  attachListeners() {
    if(this.btn) {
      this.btn.addEventListener('click', (e) => {
        e.preventDefault();
        if(!this.form || !this.collectionGrid) return;

        this.showLoader();
        this.submitForm();
      })
    }    

    if(this.activeValues.length) {
    this.activeValues.forEach((value) => {
      value.addEventListener('click', (e) => {
        e.preventDefault();

        this.showLoader();

        const url = new URL(e.currentTarget.getAttribute('href'), window.location.href);

        this.updateURL(url.toString()),
        this.updatePage(url.toString(), this.sectionId);

      })
    })
  }
  }

  showLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');
    if(loader) {
      loader.classList.remove('hidden');
    }

    if(this.select) {
      this.select.disabled = true;
    }
  }

  hideLoader() {
    const loader = document.querySelector('.coll_main_grid_wrapper .loader');
    if(loader) {
      loader.classList.add('hidden');
    }

    if(this.select) {
      this.select.disabled = false;
    }
  }

  async submitForm() {
    const formData = new FormData(this.form);

    const priceGte = this.form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = this.form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {      
        priceGte.value = "";
        priceLte.value = "";

        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    const params = new URLSearchParams();

    const currentParams = new URLSearchParams(window.location.search);
    const hasSortBy = formData.has('sort_by');

    for(const [key, value] of currentParams.entries()) {
      if(!key.startsWith('filter.v.') && !key.startsWith('filter.p.')) {
        if(key === 'sort_by' && hasSortBy) {
          continue;
        }
        params.append(key,  value);
      }
    }

    for(const [key, value] of formData.entries()) {
      if(value && value != "") {
        if(key === "sort_by") {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      }
    }

    const url = `${window.location.pathname}?${params.toString()}`;

    await this.updateURL(url);
    await this.updatePage(url, this.sectionId);
  }  

  async updateURL(url) {
    history.pushState(null, "", url);
  }

  async updatePage(url, id) {
    const newURL = url.includes('?')
  ? `${url}&sections=${id}`
  : `${url}?sections=${id}`;
    
    fetch(newURL)
    .then((res) => res.json())
    .then((htmlString) => {

      const temp = document.createElement('div');
      temp.innerHTML = htmlString[id];

      const newWrapper = temp.querySelector('.coll_main_main_inner');
      const oldWrapper = document.querySelector('.coll_main_main_inner');

      if(oldWrapper && newWrapper) {
        oldWrapper.innerHTML = newWrapper.innerHTML
      }

      const newCount = temp.querySelector('.collection_products_count');
      const oldCount = document.querySelector('.collection_products_count');

      if(oldCount && newCount) {
        oldCount.innerHTML = newCount.innerHTML;
      }

      const newMobileDrawer = temp.querySelector('.mobile_filter_drawer');
      const oldMobileDrawer = this.drawer;

      if(oldMobileDrawer && newMobileDrawer) {
        oldMobileDrawer.innerHTML = newMobileDrawer.innerHTML;
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url: url,
            sectionId: this.sectionId
          }
        })
      )

    })
    .finally(() => {
      closeDrawer(this.drawer);
    })
  }

}

customElements.define('mobile-filters', MobileFilters);

class SearchResetButton extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form[role="search"]');
    this.btn = this.querySelector('.button_reset');    
  }

  connectedCallback() {
    this.btn.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();
    const url = new URL(window.location.href);
    url.search = '';
    window.location.href = url.toString();
  }
}

customElements.define('search-reset-button', SearchResetButton);
